module.exports = __webpack_public_path__ + "img/button-POP-double.6c095b61.svg";